import { ScheduleBacnetTranslations } from "./scheduleBacnetTranslations";

export const enScheduleBacnetTranslations: ScheduleBacnetTranslations = {

    schedulesList: "Schedule list",
    weeklySchedule: "Weekly schedule",
    exceptions: "Exceptions",

    newWindow: "New window",

    more: "More",

    today: "Today",
    day: "Day",
    workWeek: "Working week",

    createWeeklySchedule: "Create weekly schedule",
    editWeeklySchedule: "Edit weekly schedule",
    createException: "Create exception",
    editException: "Edit exception",
    editExceptions: "Edit exceptions",

    event: "Event",
    exception: "Exception",

    areYouSureYouWantToDelete: "Are you sure you want to delete",

    deletion: "Deletion",
    eventDeleteConfirmation: "Are you sure you want to delete event?",

    edit: "Edit",
    add: "Add",
    exceptionFieldPriority: "Priority",

    addWeekSchedule: "Add weekly schedule",
    addException: "Add exception",
    editEvent: "Edit event",
    deleteEvent: "Delete event",
    duplicateEvent: "Duplicate event",

    time: "Time",
    dataType: "Data type",
    value: "Value",

    chooseDataType: "Choose data type",

    period: "Period",
    choosePeriod: "Choose period",

    date: "Date",
    range: "Range",
    weekAndDay: "Week and day",

    enterYear: "Enter year",

    errorPeriodTypeNotChosen: "Period type not set",
    errorIncorrectDayOfMonth: "Invalid day of the month",
    errorIncorrectDayOfWeek: "Invalid day of the week",
    errorStartDateBeforeEndDate: "Start date must be earlier than end date",
    errorDaysOfMonthDoNotMatch: "Days of the month do not match",
    errorMonthsDoNotMatch: "Months do not match",
    errorNeedToChooseCalendarId: "Calendar ID is required",

    errorNoDaysSelected: "Day of the week not selected",
    errorNoEventsAdded: "No events added",
    errorNoTimeSelected: "Time not selected",
    errorNoDataTypeSelected: "Data type not selected",
    errorNoValueSelected: "Value not selected",
    errorValuesDoNotMatchType: "Value does not match the data type",

    errorValueMustBeNonNegativeInteger: "Value must be a non-negative integer",
    errorValueMustBeInteger: "Value must be an integer",
    errorValueMustBeNumber: "Value must be a number",

    unknownValue: "Unknown value",
    valuesNotFound: "Value not found",

    dayOfWeek: "Day of the week",
    dayOfMonth: "Day of the month",
    week: "Week",
    month: "Month",
    year: "Year",
    anyDayAnyMonthAnyYear: "Any day, any month, any year",

    start: "Start",
    end: "End",

    calendarLink: "Calendar link",
    calendarID: "Calendar ID",

    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",

    daysOfWeek: "Days of the week",

    su: "Sun",
    mo: "Mon",
    tu: "Tue",
    we: "Wed",
    th: "Thu",
    fr: "Fri",
    sa: "Sat",

    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "friday",
    saturday: "Saturday",

    anyWeekDay: "Any day of the week",

    anyDayOfMonth: "Any day of the month",
    lastDay: "Last day",
    oddDays: "Odd days",
    evenDays: "Even days",

    anyMonth: "Any month",
    evenMonths: "Even months",
    oddMonths: "Odd months",

    anyYear: "Any year",
    selected: "Selected",

    anyWeek: "Any week",
    firstWeek: "1st week",
    secondWeek: "2nd week",
    thirdWeek: "3rd week",
    fourthWeek: "4th week",
    fifthWeek: "5th week",
    lastSevenDaysOfMonth: "Last 7 days of the month",

};
